module.exports = __webpack_public_path__ + "img/checkin_cohete.b9c8f30a.svg";